import { Box } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

interface Props {
  containerRef: React.RefObject<HTMLDivElement>;
  subjectPropertyContent?: React.ReactNode;
  children: React.ReactNode;
}

const PropertiesContainer = styled(Box)`
  display: flex;
  border-radius: 0.5rem;
  background-color: ${(p) => p.theme.colors.background2};
  overflow: hidden;
`;

const SubjectPropertySlot = styled(Box)`
  width: 220px;
  flex-shrink: 0;

  ${(p) => p.theme.media.mobileDown} {
    width: 160px;
  }
`;

const ScrollableContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const SideBySideComparisonCarousel = ({
  containerRef,
  subjectPropertyContent,
  children,
}: Props) => {
  return (
    <PropertiesContainer>
      {!!subjectPropertyContent && (
        <SubjectPropertySlot>{subjectPropertyContent}</SubjectPropertySlot>
      )}
      <ScrollableContainer ref={containerRef}>{children}</ScrollableContainer>
    </PropertiesContainer>
  );
};
